<template>
  <div class="buy-set-content pl16 pr16">
    <div class="common-form mt50" style="font-size: 20px">销量排序设置</div>
    <el-row :gutter="40" style="max-width: 890px">
      <el-col :span="12">
        <el-form-item label="初始销量：" class="labelStyle">
          <el-input type="number" min="0" v-model="form.model.salesInitial" class="w-full"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="商品排序：" class="labelStyle" :rules="[{ required: true, message: ' ' }]"
                      prop="model.productSort">
          <el-input type="number" min="0" v-model="form.model.productSort" class="w-full"></el-input>
        </el-form-item>
      </el-col>
    </el-row>


    <!--积分设置-->
    <div class="common-form" style="font-size: 20px">积分设置</div>
    <el-form-item label="是否开启积分赠送：" class="labelStyle">
      <el-radio-group v-model="form.model.isPointsGift">
        <el-radio :label="1">开启</el-radio>
        <el-radio :label="0">关闭</el-radio>
      </el-radio-group>
    </el-form-item>
    <el-row :gutter="40" style="max-width: 890px">
      <el-col :span="12">
        <el-form-item label="是否允许使用积分抵扣：" class="labelStyle">
          <el-radio-group v-model="form.model.isPointsDiscount">
            <el-radio :label="1">允许</el-radio>
            <el-radio :label="0">不允许</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item v-if="form.model.isPointsDiscount == 1" label="最大抵扣积分数量："
                      class="labelStyle"
                      :rules="[{ required: true, message: ' ' }]" prop="model.maxPointsDiscount">
          <el-input type="number" min="0" v-model="form.model.maxPointsDiscount"
                    onkeyup="value=value.replace(/[^\d]/g,'')"
                    @change="onMaxPointsDiscountChhangeClick" class="w-full"></el-input>
        </el-form-item>
      </el-col>
    </el-row>


    <!--会员折扣设置-->
    <div class="common-form mt50" style="font-size: 20px">会员折扣设置</div>
    <el-row :gutter="40" style="max-width: 890px">
      <el-col :span="12">
        <el-form-item label="是否开启会员折扣：" class="labelStyle">
          <el-radio-group v-model="form.model.isEnableGrade">
            <el-radio :label="1">开启</el-radio>
            <el-radio :label="0">关闭</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="会员折扣设置：" v-if="form.model.isEnableGrade === 1" class="labelStyle">
          <el-radio-group v-model="form.model.isAloneGrade">
            <el-radio :label="0">默认折扣</el-radio>
            <el-radio :label="1">单独设置折扣</el-radio>
          </el-radio-group>
          <div class="gray9" v-if="form.model.isAloneGrade==0">默认折扣：默认为用户所属会员等级的折扣率</div>
        </el-form-item>
      </el-col>
    </el-row>
    <el-form-item label="折扣类型：" v-if="form.model.isAloneGrade==1 && form.model.isEnableGrade" class="labelStyle">
      <el-radio-group v-model="form.model.aloneGradeType" @change="changeGradeType">
        <el-radio :label="10">百分比</el-radio>
        <el-radio :label="20">固定金额</el-radio>
      </el-radio-group>
    </el-form-item>

    <el-form-item label="" v-if="form.model.isAloneGrade==1 && form.model.isEnableGrade">
      <div class="max-w460">
        <el-table :data="form.gradeList" border size="mini" style="width: 100%">
          <el-table-column prop="name" label="会员等级" class="labelStyle">
          </el-table-column>
          <el-table-column prop="name" label="折扣" class="labelStyle">
            <template v-slot="scope">
              <div class="d-s-c">
                <el-input v-model="scope.row.productEquity" type="number" min="0"
                          onkeyup="value=value.replace(/[^\d]/g,'')"
                          @change="onProductEquityChhangeClick($event,scope.row)" placeholder="请输入折扣"></el-input>
                <span class="ml10">{{ gradeUnit }}</span>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-form-item>

    <!--分销设置-->
    <div class="common-form mt50" style="font-size: 20px">分销佣金设置</div>
    <el-form-item label="是否开启分销：" class="labelStyle">
      <el-radio-group v-model="form.model.isEnableCommission">
        <el-radio :label="1">开启</el-radio>
        <el-radio :label="0">关闭</el-radio>
      </el-radio-group>
    </el-form-item>

    <!--    <el-form-item label="佣金类型：" v-if="form.model.isEnableCommission==1">-->
    <!--      <el-radio-group v-model="form.model.commissionType" @change="changeAgentMoneyType">-->
    <!--        <el-radio :label="10">百分比</el-radio>-->
    <!--        <el-radio :label="20">固定金额</el-radio>-->
    <!--      </el-radio-group>-->
    <!--    </el-form-item>-->

    <!--    <el-form-item label="" v-if="form.model.isEnableCommission==1" label="佣金："-->
    <!--                  :rules="[{ required: true, message: ' ' }]" prop="model.commissionMoney">-->
    <!--      <div class="max-w460">-->

    <!--        &lt;!&ndash;          <el-input type="number" min="0" v-model="form.model.maxPointsDiscount" class="max-w460"></el-input>&ndash;&gt;-->

    <!--        &lt;!&ndash;        <el-table :data="form.gradeList" border size="mini" style="width: 100%">&ndash;&gt;-->
    <!--        &lt;!&ndash;          <el-table-column prop="name" label="会员等级">&ndash;&gt;-->
    <!--        &lt;!&ndash;          </el-table-column>&ndash;&gt;-->
    <!--        &lt;!&ndash;          <el-table-column prop="name" label="折扣">&ndash;&gt;-->
    <!--        &lt;!&ndash;            <template v-slot="scope">&ndash;&gt;-->
    <!--        <div class="d-s-c">-->
    <!--          <el-input v-model="form.model.commissionMoney" type="number" placeholder="请输入佣金" min="0"-->
    <!--                    onkeyup="value=value.replace(/[^\d]/g,'')" @change="onFirstMoneyChangeClick"-->
    <!--                    style="width: 35%"></el-input>-->
    <!--          <span class="ml10">{{ agentUnit }}</span>-->
    <!--        </div>-->
    <!--        &lt;!&ndash;            </template>&ndash;&gt;-->
    <!--        &lt;!&ndash;          </el-table-column>&ndash;&gt;-->
    <!--        &lt;!&ndash;        </el-table>&ndash;&gt;-->
    <!--      </div>-->
    <!--    </el-form-item>-->

    <Table :position="2"></Table>
  </div>
</template>

<script>
import Table from './spec/many/Table'

export default {
  components: {
    /*规格表格*/
    Table
  },
  data () {
    return {
      unit: '%',
      gradeUnit: '%',
      agentUnit: '%'
    }
  },
  created () {
    if (this.form.model.aloneGradeType == '20') {
      this.gradeUnit = '元'
    }
    if (this.form.model.commissionType == '20') {
      this.agentUnit = '元'
    }
  },
  inject: ['form'],
  methods: {
    onFirstMoneyChangeClick (e) {
      if (e.length <= 0 || e < 0) {
        this.$nextTick(() => {
          this.form.model.commissionMoney = 0
        })
      }
    },
    onMaxPointsDiscountChhangeClick (e) {
      if (e.length <= 0 || e < 0) {
        this.$nextTick(() => {
          this.form.model.maxPointsDiscount = 0
        })

      }
    },
    onProductEquityChhangeClick (e, row) {

      if (e.length <= 0 || e < 0) {
        this.$nextTick(() => {
          row.productEquity = 0
        })

      }
    },
    /*换算单位*/
    changeMoneyType: function (val) {
      if (val == '10') {
        this.unit = '%'
      } else {
        this.unit = '元'
      }
    },
    /*换算单位*/
    changeGradeType: function (val) {
      if (val == '10') {
        this.gradeUnit = '%'
      } else {
        this.gradeUnit = '元'
      }
    },
    /*换算分销佣金单位*/
    changeAgentMoneyType (val) {
      if (val == '10') {
        this.agentUnit = '%'
      } else {
        this.agentUnit = '元'
      }
    },
  }
}
</script>

<style lang="css" scoped>
.labelStyle >>> .el-form-item__label {
  font-size: 16px;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/views/product/product/part/Buyset.vue